import { getTemplateTemplateScaffoldStyles } from './Layout.styles'

// Enterprise Nav Template - Conditional sidebar
const tNavEnterprise = document.createElement('template')
tNavEnterprise.innerHTML = `
  <slot name="nav-enterprise"></slot>
`

// Nave Portal Template - Conditional application navigation
const tNavPortal = document.createElement('template')
tNavPortal.innerHTML = `
  <slot name="nav-portal"></slot>
`

// Layout Footer Template - Conditional footer
const tLayoutFooter = document.createElement('template')
tLayoutFooter.innerHTML = `
  <footer class="footer-container">
    <slot name="layout-footer"></slot>
  </footer>
`

// Main Page Template - All slots available immediately
const tPage = document.createElement('template')
tPage.innerHTML = `
  <main class="layout-container">

    <section class="main-content-container">
      <header class="header-container">
        <slot name="layout-header"></slot>
      </header>

      <section class="body-container">

        <!-- nav-enterprise will be inserted here if enable-enterprise-nav="true" -->

        <section class="content-container">

          <!-- portal-nav will be inserted here if enable-portal-nav="true" -->

          <section class="main-content">
            <section class="main">
              <slot></slot>
            </section>

            <!-- main-footer will be inserted here if enable-main-footer="true" -->

          </section>
        </section>

      </section>
    </section>
  </main>
`

class Page extends HTMLElement {
  constructor() {
    super()
    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateTemplateScaffoldStyles().content.cloneNode(true))
    shadow.appendChild(tPage.content.cloneNode(true))
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('Layout connectedCallback')
    // Initialize enterprise nav, portal nav, and layout footer if enabled
    this.updateEnterpriseNav()
    this.updatePortalNav()
    this.updateLayoutFooter()
    this.addEventListener('toggle-hamburger', this.onToggle)
  }

  private onToggle = () => {
    const mobileMenu = this.querySelector('ts-navportal') as HTMLElement | null
    mobileMenu?.toggleAttribute('mobile-menu-open')
    const enterpriseNav = this.querySelector('ts-nav-enterprise') as HTMLElement | null
    // Open-only: repeated toggle-hamburger events never close the enterprise nav.
    // Closing is handled internally by ts-nav-enterprise via its close button.
    enterpriseNav?.setAttribute('enterprise-nav-open', '')
  }

  static get observedAttributes() {
    return ['enable-enterprise-nav', 'enable-portal-nav', 'enable-main-footer']
  }

  attributeChangedCallback(name: string) {
    if (name === 'enable-enterprise-nav') {
      this.updateEnterpriseNav()
    } else if (name === 'enable-portal-nav') {
      this.updatePortalNav()
    } else if (name === 'enable-main-footer') {
      this.updateLayoutFooter()
    }
  }

  updateEnterpriseNav() {
    const enableEnterpriseNav = this.getAttribute('enable-enterprise-nav') === 'true'
    const shadow = this.shadowRoot
    if (!shadow) return

    const layoutContainer = shadow.querySelector('.layout-container') as HTMLElement | null
    const bodyContainer = shadow.querySelector('.body-container')
    const contentContainer = shadow.querySelector('.content-container')
    const existingEnterpriseNav = shadow.querySelector('slot[name="nav-enterprise"]')

    // Toggle CSS class so the header can be hidden on desktop via CSS only
    layoutContainer?.classList.toggle('has-enterprise-nav', enableEnterpriseNav)

    if (enableEnterpriseNav) {
      // Add enterprise nav if it doesn't exist
      if (!existingEnterpriseNav && bodyContainer && contentContainer) {
        const enterpriseNavElement = tNavEnterprise.content.cloneNode(true)
        bodyContainer.insertBefore(enterpriseNavElement, contentContainer)
      }
    } else {
      // Remove enterprise nav if it exists
      if (existingEnterpriseNav) {
        existingEnterpriseNav.remove()
      }
    }
  }

  updatePortalNav() {
    const enablePortalNav = this.getAttribute('enable-portal-nav') === 'true'
    const shadow = this.shadowRoot
    if (!shadow) return

    const contentContainer = shadow.querySelector('.content-container')
    const mainContent = shadow.querySelector('.main-content')
    const existingPortalNav = shadow.querySelector('.nav-portal-container')

    if (enablePortalNav) {
      // Add portal nav if it doesn't exist
      if (!existingPortalNav && contentContainer && mainContent) {
        const portalNavElement = tNavPortal.content.cloneNode(true)
        contentContainer.insertBefore(portalNavElement, mainContent)
      }
    } else {
      // Remove portal nav if it exists
      if (existingPortalNav) {
        existingPortalNav.remove()
      }
    }
  }

  updateLayoutFooter() {
    const enableLayoutFooter = this.getAttribute('enable-main-footer') === 'true'
    const shadow = this.shadowRoot
    if (!shadow) return

    const contentContainer = shadow.querySelector('.main-content')
    const existingFooter = shadow.querySelector('.footer-container')

    if (enableLayoutFooter) {
      // Add layout footer if it doesn't exist
      if (!existingFooter && contentContainer) {
        const footerElement = tLayoutFooter.content.cloneNode(true)
        contentContainer.appendChild(footerElement)
      }
    } else {
      // Remove layout footer if it exists
      if (existingFooter) {
        existingFooter.remove()
      }
    }
  }
}

if (!customElements.get('ts-layout')) {
  customElements.define('ts-layout', Page)
}
export { Page }
